import {isNil} from 'ramda';

import {DefinitionWithTemplatesResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

// Matched by id and scoped to each template's own definition and profile, because the two endpoints
// disagree on some documentCodes and a failed join scored every template non-primary.
export const getPrimaryTemplateIds = (
  definitions: DefinitionWithTemplatesResponseBody[] | Nullish
) =>
  new Set(
    definitions?.flatMap((definition) =>
      definition.templates
        .filter((template) =>
          isNil(template.authorizationProfileId)
            ? template.id === definition.primaryTemplateId
            : template.id ===
              definition.authorizationProfiles.find(
                (profile) => profile.authorizationProfileId === template.authorizationProfileId
              )?.primaryTemplateId
        )
        .map((template) => template.id)
    ) ?? []
  );
